import { render, staticRenderFns } from "./BuildingRegisterPage.vue?vue&type=template&id=655b7c1b&"
import script from "./BuildingRegisterPage.vue?vue&type=script&lang=ts&"
export * from "./BuildingRegisterPage.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports